export const colors = {
  white: '#FFF',
  black: '#000',
  blackShade2: '#212121',
  dark1: '#747176',
  softBlack: '#16181C',
  orange: '#FF6E00',
  orange2: '#FFA800',
  gray: '#F8F8FA',
  main: '#FF5D00',
  dark: '#0A000F',
  yellow: '#FFD500',
  blue: '#2A5AF7',
  red: '#FF3B16',
  indigo: '#4F46E5',

  // Management colors
  link: '#1890FF',
  hoveredLink: '#40A9FF',
  yellowDark: '#FFD231',
  yellowLight: '#FFE178',
  success: '#47A82B',

  // Rebound colors
  darkenBlack: '#262626',
  darkenBlack2: '#18191D',
  lightBlue: '#EEF2FE',
  grayLight: '#f9fafb',
  grayLight2: '#F3F4F6',
  grayLight3: '#9ca3af',
  grayLight4: '#E5E7EB',
  grayDark: '#6b7280',
  grayDark2: '#d1d5db',
  grayDark3: '#374151',
  grayDark4: '#111827',
  grayDark5: '#4B5563',
  grayDark6: '#1F2937',
  grayDark7: '#3B3D47',
  grayDark8: '#1F2A37',
  warningYellow1: '#FFFBEB',
  warningYellow2: '#B45309',
  errorRed: '#EF4444',
  errorRed2: '#FCA5A5',
  errorRed3: '#FEF2F2',
  errorRed4: '#991B1B',
  errorRed5: '#F87171',
  errorRed6: '#FEE2E2',
  errorRed7: '#B91C1C',
  lightGreen: '#2dc254',
};
